import React from 'react';
import { Card, CardContent, Typography, withStyles, Grid } from '@material-ui/core';

const styles = theme => ({
	card: {
		border: `1px solid ${theme.palette.grey['300']}`,
		boxShadow: 'none',
		borderRadius: '2px',
	},
	title: {
		fontSize: 14,
	},
});

const StyledCard = props => {
	const { title, classes, children, sizes, noBorder } = props;
	return (
		<Grid item {...sizes}>
			<Card className={classes.card} style={{ border: noBorder ? 0 : '1px solid #e0e0e0 ' }}>
				<CardContent>
					{title && (
						<Typography className={classes.title} color="textSecondary" gutterBottom>
							{title}
						</Typography>
					)}
					{children}
				</CardContent>
			</Card>
		</Grid>
	);
};

export default withStyles(styles)(StyledCard);
